import { Children, ReactNode, ElementType } from 'react'
import cn from 'classnames/bind'

import { NavItem, isNavItem } from './nav-item'

import styles from './plain-nav.module.scss'
import { isEmpty } from 'ramda'

const cx = cn.bind(styles)

type Props = {
  children: ReactNode
  className?: string
  NavComponent?: ElementType
  skipVerticalMargin?: boolean
  keepHeightOnEmpty?: boolean
}

const PlainNav = ({
  children,
  className,
  NavComponent = 'a',
  skipVerticalMargin,
  keepHeightOnEmpty,
}: Props) => {
  const empty = isEmpty(Children.toArray(children))
  if (empty && !keepHeightOnEmpty) {
    return <div className={cx(styles.root, { skipVerticalMargin }, className)}>&nbsp;</div>
  }
  return (
    <nav className={cx(styles.root, { skipVerticalMargin }, className)}>
      {Children.map(children, (child) => {
        if (isNavItem(child)) {
          const { props, key } = child
          const { children: ch, active, disabled, ...others } = props // eslint-disable-line react/prop-types

          if (disabled) {
            return (
              <span className={cx({ active, disabled })} key={key}>
                {ch}
              </span>
            )
          }

          return (
            <NavComponent {...others} className={cx({ active })} key={key}>
              {ch}
            </NavComponent>
          )
        }
        return child
      })}
    </nav>
  )
}

PlainNav.Item = NavItem

export default PlainNav
